import { render } from "./ErrorPanel.vue?vue&type=template&id=57992a8b&scoped=true&ts=true"
import script from "./ErrorPanel.vue?vue&type=script&lang=ts"
export * from "./ErrorPanel.vue?vue&type=script&lang=ts"

import "./ErrorPanel.vue?vue&type=style&index=0&id=57992a8b&scoped=true&lang=css"

import exportComponent from "/home/runner/work/qti-player/qti-player/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57992a8b"]])

export default __exports__